<template>
    <form @submit.prevent="SubmitForm()">

        <b-loading :is-full-page="loading_fullpage" :active.sync="is_uploading" :can-cancel="true">
        </b-loading>

        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Upload Reviewable</p>
            </header>

            <section v-if="pre_submit" class="modal-card-body">
                
                <b-field v-if="files.length < 2" label="Name">
                    <b-input
                        v-model="name"
                        placeholder="Customise name"
                    >
                    </b-input>
                </b-field>

                <b-field label="Notes">
                    <b-input
                        v-model="notes"
                        placeholder="Add notes"
                    >
                    </b-input>
                </b-field>

                <b-field label="Project">
                    <b-autocomplete
                        required
                        v-model="project_autocomplete_name"
                        :data="filteredDataArray_Project"
                        :loading=project_names_loading
                        placeholder="Pick a project!"
                        icon="magnify"
                        @select="option => ProjectSelected(option)"
                    >
                        <template slot="empty">No results found</template>
                    </b-autocomplete>
                </b-field>

                <b-field label="Shot">
                    <b-autocomplete
                        v-model="shot_autocomplete_name"
                        :data="filteredDataArray_Shot"
                        :open-on-focus=true
                        :loading=shots_loading
                        placeholder="Pick a shot!"
                        icon="magnify"
                        @select="option => shot_autocomplete_selected = option"
                    >
                        <template slot="empty">No results found</template>
                    </b-autocomplete>
                </b-field>

                <b-checkbox v-model="publish">
                    Flagged
                    <b-icon icon="flag"></b-icon>
                </b-checkbox>

            </section>

            <footer class="modal-card-foot">
                <button class="button is-primary">{{ upload_button_text }}</button>
                    <div>
                        <b-progress v-if="is_uploading" :value=upload_percentage show-value format="percent"></b-progress>
                        
                        <div class="box has-text-centered den-upload-box"
                            v-for="(file, file_index) in files_display"
                        >
                            <div v-if="uploaded_ids.length < 1">
                                <b-icon
                                    icon="file-outline"
                                    size="is-small">
                                </b-icon>
                                {{file.name}} ({{ formatBytes(file.size) }})
                            </div>

                            <div v-else>
                                <b-icon
                                    icon="open-in-new"
                                    size="is-small">
                                </b-icon>

                                <router-link @click.native="CloseForm()" :to="{ name: 'single', params: {id: uploaded_ids[file_index] } }">
                                    {{file.name}}
                                </router-link>
                            </div>
                        </div>
                        <div v-if="lots_of_files" class="box has-text-centered den-upload-box">
                            + {{ files.length - 5 }} more files
                        </div>
                    </div>
            </footer>
        </div>
    </form>
</template>

<script>
    import axios from 'axios'

    import { GetProjectNames } from '../mixins/Projects'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [GetProjectNames, GetAxiosAuthConfig],
        data() {
            return {
                isComponentModalActive: false,
                notes: '',
                name: 'placeholder',
                project_autocomplete_name: '',
                project_autocomplete_selected: null,
                shot_autocomplete_name: '',
                shot_autocomplete_selected: null,

                is_uploading: false,
                loading_fullpage: false,

                publish: true,
                // UI to change after upload pressed
                pre_submit: true,
                upload_button_text: 'Upload',

                shot_names: [],
                shots_loading: false,

                // after upload
                uploaded_ids: [],
                upload_percentage: 0,

                lots_of_files: false,
            }
        },
        props: {
            files : Array
        },
        computed: {
            filteredDataArray_Project() {
                return this.project_names.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.project_autocomplete_name.toLowerCase()) >= 0
                })
            },
            filteredDataArray_Shot() {
                return this.shot_names.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.shot_autocomplete_name.toLowerCase()) >= 0
                })
            },
            files_display() {
                // if there are too many files it breaks the form
                // so limit how many are visible
                let display_max = 5

                // return new_list
                if (this.files.length > display_max) {
                    this.lots_of_files = true
                }
                return this.files.slice(0,5)
            }
        },
        methods: {
            ProjectSelected(option) {
                this.project_autocomplete_selected = option
                this.GetShotNames()
            },
            CloseForm() {
                this.$parent.close()
            },
            SubmitForm() {
                // If in pre_submit mode, submitting the dialog uploads the file, if not it closes the dialog
                if (this.pre_submit) {
                    // loop through files array
                    for (const file of this.files) {
                        this.UploadReviewable(file)
                    }

                    this.upload_button_text = 'Finished'
                    this.pre_submit = false
                    // also reset this
                    this.lots_of_files = false
                    // empty the file list
                    this.files = []
                    return
                }
                else {
                    // Close dialog
                    this.$parent.close()
                    // empty the file list
                    this.files = []
                    return
                }               
            },
            UploadReviewable(file) {
                this.is_uploading = true

                let resturl = window.location.origin + '/api/reviewables/'

                // Make a formdata object to pass data to the API
                let formData = new FormData()

                // check localstorage item exists, older logins didnt
                if (localStorage.getItem("den_user") === null) {
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Error, please try logging out and in again.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'alert-outline',
                        iconPack: 'mdi'
                    })
                    // Close dialog
                    this.$parent.close()
                    return
                }

                // the 'den_user' param would be like Joe Bloggs so shorten this like initial-surname
                let user_names = localStorage.getItem('den_user').split(" ")
                let user = (user_names[0][0] + user_names.slice(-1)).toLowerCase()
                
                // only use form name if it was customised (only on single file uploads)
                let name = ""

                if (this.files.length > 1) {
                    name = file.name
                }
                else {
                    name = this.name    
                }
                console.log('name', name)
                formData.append('name', name)
                formData.append('user', user)
                formData.append('path', 'plarp')
                formData.append('sourcepath', '')
                formData.append('action', 'web-upload')
                formData.append('notes', this.notes)
                formData.append('project', this.project_autocomplete_name)
                formData.append('shot', this.shot_autocomplete_name)
                formData.append('version', false)
                formData.append('file_upload', file)
                formData.append('published', this.publish)

                // merge axios auth headers with upload required
                let upload_headers = {
                    'Content-Type': 'multipart/form-data'
                }

                let headers = Object.assign({}, upload_headers, axios_auth_config.headers);
  
                axios.post(resturl,
                    formData,
                    {
                        headers: headers,
                        onUploadProgress: function( progressEvent ) {
                            let percentage = Math.round(( progressEvent.loaded / (progressEvent.total) ) * 100 )
                            // max 95, then set 100 when request is done
                            this.upload_percentage = Math.min(Math.max(parseInt(percentage), 0), 95)
                        }.bind(this)
                    })
                    .then(response => {
                        console.info('upload response', response)

                        // status 201 is 'Created'
                        if (response.status == 201) {
                            this.$buefy.toast.open({
                                message: 'Uploaded: ' + file.name,
                                type: 'is-success'
                            })

                            // add 'id' of each new reviewables made on api to array
                            this.uploaded_ids.push(response.data.id)
                        }
                        // set as 100 when done
                        this.upload_percentage = 100

                        // Finished loading
                        this.is_uploading = false
                    })
                    .catch(error => console.log(error))

                // Reset list
                // this.dropFiles = []
            },
            GetShotNames() {
                // this is called when a project has been picked
                console.info('GetShotNames()...')
                let shot_names = []

                // Init as loading
                this.shots_loading = true

                // this gets projects from the database list
                let resturl_project = window.location.origin + '/api/projects/?name=' + this.project_autocomplete_selected

                axios.get(resturl_project, axios_auth_config)
                .then(response_project => {
                    console.info("response_project", response_project)

                    // get shot set of project
                    // skip if no results
                    if (response_project.data.count == 0) {
                        this.shot_names = shot_names
                        return
                    }

                    response_project.data.results[0]["shot_set"]

                    for (let shot of response_project.data.results[0]["shot_set"]) {
                        shot_names.push(shot.name)
                    }

                    this.shot_names = shot_names
                    this.shots_loading = false
                })
                .catch(error => console.log(error))
            },
            formatBytes(bytes) {
                if (bytes === 0) return '0 Bytes';

                let decimals = 2
                let k = 1024;
                let dm = decimals < 0 ? 0 : decimals
                let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                let i = Math.floor(Math.log(bytes) / Math.log(k));

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
        },
        mounted() {
            // this occurs when the dialog is opened, after picking a file

            // set this name using the first uplaoded file (doesnt matter when multiple)
            this.name = this.files[0].name

            if (this.$route.params.project != undefined) {
                this.project_autocomplete_name = this.$route.params.project
                // this one for the shot list
                this.project_autocomplete_selected = this.project_autocomplete_name
                this.GetShotNames()
            }
            if (this.$route.params.shot != undefined) {
                this.shot_autocomplete_name = this.$route.params.shot
            }
        }
}
</script>


<style scoped lang="scss">

    .den-upload-box {
        padding: 0.5rem;
        margin: 1rem;
    }
    .modal-card {
        overflow: visible
    }

    .modal-card-body {
        overflow: visible
    }

</style>
